<template>
    <svg style="box-sizing: border-box; position:absolute; right: 0; left: 0; top: 0; bottom: 0; opacity: 0.6; height: 100%; width: 100%" preserveAspectRatio="none" role="img" viewBox="0 0 42 23" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <filter color-interpolation-filters="sRGB" id="blurMe">
            <feGaussianBlur edgeMode="duplicate" tableValues="1 1" stdDeviation="1.2" />
            <feComponentTransfer>
                <feFuncA tableValues="1 1" type="discrete"></feFuncA>
            </feComponentTransfer>
        </filter>
        <image filter="url(#blurMe)" height="23" width="42" x="0" :xlink:href="url" y="0"></image>
    </svg>
</template>

<script>
    export default {
        name: 'BackgorundBlur',
        props: [
            'url'
        ],
    }
</script>


